import React from "react";
import {
  PencilSquareIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";

const EllipsisCard = (props) => {
  const {
    userPermission,
    editPermission,
    deletePermission,
    nsaHierarchyData,
    splcHierarchyData,
  } = props;

  const edit = userPermission?.includes(editPermission);
  const deactivate = userPermission?.includes(deletePermission);
  const isDisabled =
    !nsaHierarchyData?.isActive && !splcHierarchyData?.isActive;

  return (
    <div className="ellipsis-card-container">
      <button className="absolute -top-2 -right-2">
        <XCircleIcon className="onClose text-octonary cursor-pointer" />
      </button>

      {edit && (
        <button
          className={`isEdit flex items-center place-content-center hover:text-primary ${
            !deactivate ? "mr-9 mb-1" : ""
          }`}
        >
          <PencilSquareIcon className="h-4 w-4 mr-1" />
          Edit
        </button>
      )}
      {deactivate && (
        <button
          className={
            isDisabled
              ? "isDeactivate opacity-50 flex items-center place-content-center hover:text-primary mt-1"
              : "isDeactivate flex items-center place-content-center hover:text-primary mt-1"
          }
          disabled={isDisabled}
        >
          <TrashIcon className="h-4 w-4 mr-1" />
          Deactivate
        </button>
      )}
    </div>
  );
};

export default EllipsisCard;
